// extracted by mini-css-extract-plugin
module.exports = {"container":"V4WVSK5awJB+UuVuNi0tlw==","divBtn":"qonintfxu1c9qYpyVijDWA==","delBtn":"gwKZ4B6vRpN0bGbtfjmItQ=="};